import React, { PureComponent } from 'react';
import { Loader } from 'react-loaders';
import { batchRequest } from '../../api/ApiService';
import Auth from '../../routes/Auth';
import { Modal } from "react-bootstrap";

import MarketShareVideo from '../../containers/assets/goals-and-targets-market-share.mp4';
import RevenuesVideo from '../../containers/assets/goals-and-targets-revenues.mp4';
import GrossMarginsVideo from '../../containers/assets/goals-and-targets-gross-margins.mp4';
import SharePriceVideo from '../../containers/assets/goals-and-targets-share-price.mp4';
import RoeVideo from '../../containers/assets/goals-and-targets-roe.mp4';
import RoaVideo from '../../containers/assets/goals-and-targets-roa.mp4';
import EpsVideo from '../../containers/assets/goals-and-targets-eps.mp4';

import {
  Wrapper,
  Title,
  FormWrapper,
  Form,
  Description,
  InfoTooltip,
  Text,
  ModalVideoWrapper,
  PlayPauseButton,
  CloseModalVideoButton
} from '../styles/goals-and-targets';
import FinancialTargets from '../../components/dashboard/FinancialTargets';

import InfoTooltipIcon from '../../containers/assets/info-tooltip.png';

const videos = {
  'Market Share': MarketShareVideo,
  'Revenues': RevenuesVideo,
  'Gross Margins': GrossMarginsVideo,
  'Share Price': SharePriceVideo,
  'ROE': RoeVideo,
  'ROA': RoaVideo,
  'EPS': EpsVideo,
};

class GoalsAndTargets extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      financialTargets: [],
      loaded: false,
      isModalShown: false,
      isVideoPlaying: false,
      selectedVideo: null
    };

    this.videoRef = null;
  }

  handlePlayPause = () => {
    if (this.videoRef) {
      if (this.state.isVideoPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.setState({ isVideoPlaying: !this.state.isVideoPlaying });
    }
  };

  openModal = (videoSrc) => {
    this.setState({
      isModalShown: true,
      selectedVideo: videoSrc,
    });
  };

  closeModal = () => {
    this.setState({
      isModalShown: false,
      isVideoPlaying: false
    });
  };

  onHelpIconClick = (field) => {
    if (videos[field]) {
      this.openModal(videos[field]);
    }
  };


  get activeRound() {
    const { currentRound, roundInUrl } = this.props;

    return Number(roundInUrl || currentRound);
  }

  componentDidMount() {
    const courseId = Number(Auth.getCourseId());

    batchRequest([
      `${process.env.REACT_APP_API_URL}v2/games/targets/?course=${courseId}`,
      `${process.env.REACT_APP_API_URL}v2/games/goaltargets/`,
    ])
      .then(res => {
        const financialTargets = res[0].body;

        this.setState({
          financialTargets,
          loaded: true,
        });
      })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      financialTargets,
      isModalShown,
      isVideoPlaying
    } = this.state;
    const activeRound = this.activeRound;

    return loaded ? (
      <Wrapper>
        <Modal show={isModalShown} onHide={this.closeModal} className="goals-and-targets-modal">
          <Modal.Body>
            <ModalVideoWrapper className={isVideoPlaying ? 'is-playing' : ''}>
              <video
                ref={(ref) => { this.videoRef = ref; }}
                src={this.state.selectedVideo}
                alt="Welcome Video"
                onClick={this.handlePlayPause}
                onEnded={() => this.setState({ isVideoPlaying: false })}
                style={{ width: '100%', borderRadius: 10 }}
              />
              <PlayPauseButton onClick={this.handlePlayPause}>
                {isVideoPlaying ? '❚❚' : '▶'}
              </PlayPauseButton>
              <CloseModalVideoButton>×</CloseModalVideoButton>
            </ModalVideoWrapper>
          </Modal.Body>
        </Modal>
        <Title>Set Team Goals &amp; Targets</Title>
        <FormWrapper>
          <InfoTooltip>
            <img src={InfoTooltipIcon} alt="info tooltip icon" />
            <div>Benchmark: industry targets</div>
          </InfoTooltip>
          <Description>
            Below shows the financial targets that teams have to hit each year. Note not all financial metrics are relevant in each year.
          </Description>
          <Form maxWidth="800px">
            <FinancialTargets
              round={activeRound}
              financialTargets={financialTargets}
              showTableOnly={true}
              showFullTable={true}
              hideTitle={true}
              padding="0px"
              onHelpIconClick={this.onHelpIconClick}
            />
          </Form>
        </FormWrapper>
        <Text>To modify any of the targets above, please navigate to Grading (loc: Game Admin --> Grading)</Text>
      </Wrapper>
    ) : (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    );
  }

}

export default GoalsAndTargets;


// WEBPACK FOOTER //
// ./src/instructor/containers/goals-and-targets.js